import 'dotenv/config'
import { Command } from 'commander'
import { VERSION } from '@/lib/version'
import { ensureRuntimePath } from '@/lib/ensureRuntimePath'
import {
  logCommands,
  startCommand,
  stopCommand,
  updateCommands,
  stakeCommands,
  setupCommands,
  restartCommand,
  installCommands,
  cronCommands,
  statusCommands,
  scpCommands,
  getCommands,
  mountCommands,
  relayerCommands,
  dfCommands,
  logrotateCommand,
} from '@/cli'
import { balanceCommands } from './cli/balance'
import { rmLogs } from './cli/setup/rmLogs'
import { rmSnapshot } from './cli/setup/rmSnapshot'
import { monitorSolana } from './cli/get/monitorSolana'
import { solanaCatchup } from './cli/get/solanaCatchup'
import { showConfig } from './cli/get/showConfig'
import { transferCommands } from './cli/transfer'
import { withdrawCommands } from './cli/withdraw'
import { harvestCommands } from './cli/harvest'
import { epochTimerCommands } from './cli/epochTimer'
import { switchCommand } from './cli/switch'
import createSnapshot from './cli/get/createSnapshot'
import { swapCommand } from './cli/swap'
import readConfig from './config/readConfig'
import { jupiterCommands } from './cli/jupiter'
import { monitoringCommands } from './cli/monitoring'
import chalk from 'chalk'
import getSolanaVersion from './cli/epochTimer/getSolanaVersion'

export const program = new Command()
program
  .name('solv')
  .description(`🪄  solv - Solana Validator Tool ✨`)
  .helpOption('-h, --help', `Display help for command`)
  .version(VERSION, '-V', `Display version`)

async function main() {
  try {
    // Make solana-keygen / agave-validator / pnpm resolvable for all spawned
    // children, regardless of how the invoking shell set up PATH.
    ensureRuntimePath()

    // This config will be new config file - solv4.config.json
    const config = await readConfig()

    startCommand(config)
    restartCommand(config)
    stopCommand(config)
    statusCommands(config)
    updateCommands(config)
    logCommands()
    installCommands(config)
    stakeCommands(config)
    getCommands(config)
    scpCommands()
    cronCommands()
    setupCommands(config)
    balanceCommands(config)
    mountCommands()
    relayerCommands()
    transferCommands(config)
    withdrawCommands(config)
    harvestCommands(config)
    dfCommands()
    swapCommand(program, config)
    epochTimerCommands(config)
    switchCommand(program, config)
    jupiterCommands()
    logrotateCommand(config)
    monitoringCommands(config)

    program
      .command('rm:log')
      .description('Remove Logs')
      .action(() => {
        rmLogs()
      })

    program
      .command('rm:snapshot')
      .description('Remove Snapshot')
      .action(() => {
        rmSnapshot(config)
      })

    program
      .command('create:snapshot')
      .description('Create Snapshot')
      .option('-s, --slot <slot>', 'Slot', '306450862')
      .option('-l, --ledger <ledger>', 'Ledger', config.LEDGER_PATH)
      .option('-n, --snapshots <snapshots>', 'Snapshots', config.SNAPSHOTS_PATH)
      .action((options: { slot: string; ledger: string, snapshots: string }) => {
        console.log(chalk.white(`📝 Creating Snapshot...`))
        createSnapshot(options.slot, options.ledger, options.snapshots)
      })

    program
      .command('monitor')
      .alias('m')
      .description('Monitor Solana Node')
      .action(() => {
        monitorSolana(config)
      })

    program
      .command('catchup')
      .description('Check Solana Catchup Status')
      .alias('c')
      .alias('ca')
      .action(() => {
        solanaCatchup()
      })

    program
      .command('config')
      .description('Show Solv Config')
      .action(() => {
        showConfig(config)
      })

    program
      .command('vv')
      .description('Show Solv Version')
      .action(() => {
        const version = getSolanaVersion()
        console.log('version:', version)
      })

    await program
      .addHelpCommand('help [cmd]', 'Display help for command')
      .parseAsync(process.argv)
    process.exit(0)
  } catch (error) {
    console.log(error)
    process.exit(0)
  }
}

main()
